import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { QueryStatus, authAxios } from "../../utils";
import { RootState } from "../../redux/store";
import { CarIconApi } from "./carIconsApi";

export interface CarIconsState {
  carIconsToReviewStatus: QueryStatus;
  carIconsToReview: CarIconApi[];
}

const initialState: CarIconsState = {
  carIconsToReviewStatus: "idle",
  carIconsToReview: [],
};

export const carIconsToReviewAsync = createAsyncThunk(
  "carIconsToReview/call",
  async () => {
    const axios = authAxios();
    const response = await axios.get<CarIconApi[]>(
      `/vehicles/car_icons/to_review`,
    );
    return response.data;
  },
);

export const carIconsSlice = createSlice({
  name: "carIcons",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(carIconsToReviewAsync.pending, (state) => {
        state.carIconsToReviewStatus = "processing";
      })
      .addCase(carIconsToReviewAsync.fulfilled, (state, action) => {
        state.carIconsToReviewStatus = "success";
        state.carIconsToReview = action.payload;
      })
      .addCase(carIconsToReviewAsync.rejected, (state) => {
        state.carIconsToReviewStatus = "failed";
      });
  },
});

export const selectCarIconsToReview = (state: RootState) =>
  state.carIcons.carIconsToReview;
export const selectCarIconsToReviewStatus = (state: RootState) =>
  state.carIcons.carIconsToReviewStatus;

export default carIconsSlice.reducer;
